module.exports = __webpack_public_path__ + "img/sankaku_67_red.22e72d1a.png";